import { Flex } from "@aircall/tractor";
import { Body } from "../Body/Body";
import { Header } from "../Header/Header";

export function DesktopLayout() {
  return (
    <Flex flexDirection="column" h="100vh" overflow="auto">
      <Header />
      <Body />
    </Flex>
  );
}
